import * as React from "react";
const SVGComponent = ({ color = "var(--border-color)", ...props }) => (
  <svg
    width={20}
    height={16}
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.9999 13.902H2.05114V0.132812H0V15.9533H20L19.9999 13.902Z"
      fill={color}
    />
    <path d="M3.84619 8.14062H5.89752V12.9996H3.84619V8.14062Z" fill={color} />
    <path d="M8.20508 5.83301H10.2564V12.9997H8.20508V5.83301Z" fill={color} />
    <path d="M12.564 9.67871H14.6153V12.9992H12.564V9.67871Z" fill={color} />
    <path d="M16.9229 3.26904H18.9742V12.9998H16.9229V3.26904Z" fill={color} />
  </svg>
);
export default SVGComponent;
